import styled from 'styled-components';
import Typography from '../../styles/Typography';

export const StyledHeader = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  padding: 0.25rem 0.25rem 0;
  gap: 1rem;
`;

export const StyledHeaderAction = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const StyledHeaderActionColumn = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledHeaderTitle = styled(Typography).attrs({
  forwardedAs: 'h1',
  variant: 'h2',
})`
  color: ${({ theme }) => theme.colors.brand.navy};
  font-weight: 700;
  font-size: 1.625rem;
  letter-spacing: -0.02em;
  line-height: 1.2;
`;
